import {ActiveField} from '../ActiveField'

export default class NewsletterCalendarField extends ActiveField {
  constructor () {
    // @ts-ignore
    super(...arguments)
    this.fieldType = 'newsletter-recipients'
  }
}